import en from './en-GB';
import si from './si-SL';

export default {
    'en-GB': en, 
    'en-US': en,
    'sl-SI': si
}